'use client';

import type { ReactNode } from 'react';

export interface ContentWithDefaultProps {
	content?: ReactNode;
	defaultContent?: ReactNode;
}

/**
 * Display something if defined, or display a fallback
 *
 * @param props
 * @returns
 */
export function ContentWithDefault({ content: contentProp, defaultContent }: ContentWithDefaultProps): ReactNode {
	let content = contentProp;

	// Return default content
	if (content === undefined) {
		content = defaultContent;
	}

	// Make sure we return null if nothing is defined
	if (content === undefined) {
		content = null;
	}

	return content;
}
